import React, { Component } from 'react'

import { CrfContext } from "../../CrfContext";

import SideNav from "../sidenav/Sidenav";
import { Link } from 'react-router-dom';

import NoDepartmentModal from "./NoDepartmentModal"

import "./MyDepartments.css"

import axios from 'axios'

export class MyDepartments extends Component {
    state ={
        approvedRequest: false,
        requestingToJoin: [],
        userIdToApprove: "",
        userDepartments: [],
        departmentLists: [],
        toAddDept: "",

        selectDepartment: false,
        send: false

    }


    componentDidMount(){

        axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
            
          this.setState({
              userDepartments: response.data.data.departments
          })
          let headDepartment = response.data.data.department.centerName
          let departmentHead = response.data.data
        //   =========================================================================================
      

        // ===========================================================================================
           
      })
      .catch(error => {
            
        })

        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
                
    //   THIS WILL FILTER IF THE USER DEPARTMENT IS APPPROVED AND DEPARTMENT MATCH TO DEPARTMENT HEAD
            //   this.setState({
            //     requestingToJoin: response.data.data.filter(user => user.department.isApproved === false
            //         && user.department.centerName === headDepartment)
            //   })
            //     
    // ==================================================================================================
    //   this.setState({
    //             requestingToJoin: response.data.data
    //                 .filter(user => 
    //                 // user.department.isApproved === false && 
    //                 user.department.centerName === headDepartment  
    //                 &&
    //                 user._id !== departmentHead._id
    //                 )
    //           })
    //             
          })
          .catch(error => {
                
            })

            axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_KEY}/api/departments`,
              headers: {
                'Api-Key':
                  '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                Authorization: `Bearer ${localStorage.token}`
              }
            })
              .then(response => {
                  
                this.setState({
                  departmentLists: response.data.data
                })
                //   
            })
            .catch(error => {
                //   
              })
    }

    handleDepartmentStatus = (e) => {
          
        axios({
            method: 'PUT',
            url: `${process.env.REACT_APP_API_KEY}/api/userInfo/approvedDepartment/${e.target.id}`,
            data: {
                centerCode: e.target.name
            },
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
                
              window.location.reload()

            //   this.setState({
            //     requestingToJoin: response.data.data.filter(user => user.department.isApproved === false
            //         && user.department.centerName === headDepartment)
            //   })
            //     
 
          })
          .catch(error => {
                
            })
    }

    handleToAddDept = (e) => {
        
      this.setState({
        toAddDept: e.target.value
      })
    }

    handleSubmitDept = (e) => {
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/userInfo/departmentRequest/department`,
        data: {
          department: this.state.toAddDept
        },
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
              
            if(response.data.data.nModified === 1){
              this.setState({
                send: true
              })
              window.location.reload();
            }
      })
      .catch(error => {
        })
    }
    
    handleShowSelectDepartmentModal = () => {
        
      this.setState({
          selectDepartment: true,
      })
      document.getElementById('modalBody').style.display = 'block';
    }

    render() {
          
     
        return (
            <CrfContext.Consumer>
      {(context) => (
          <div id="mainPage">

            <NoDepartmentModal 
              closeReturnModal = {this.closeReturnModal}
              selectDepartment = {this.state.selectDepartment}
              waitForApproval = {this.state.waitForApproval}
              handleShowSelectDepartmentModal = {this.handleShowSelectDepartmentModal}
            />

          <div id="sidePanel">
            <SideNav 
              testState = {context.state.testState}
              toggleBtn1List = {context.toggleBtn1List}
              toggleBtn2List = {context.toggleBtn2List}
              btn1List = {context.state.btn1List}
              btn2List = {context.state.btn2List}
              userRole = {context.state.userRole}
            />
          </div>
          <div id="mainPanel">
            <div className="requestSelectionPanel">
                    <div className="toApproveHeader">
                        <div>
                            <h1>Department List</h1>
                        </div>
                      
                        {/* TABLE HEAD */}
                        <div className="myRequestTableHeader">
                            <div className="tHead2">
                                <h4></h4>
                            </div>
                            <div className="tHead2">
                                <h4></h4>
                            </div>
                            <div className="tHead2">
                                
                            </div>
                            <div className="tHead2">
                                <h4></h4>
                            </div>
                        </div>
                        {/*END TABLE HEAD */}
                    </div>
                </div>
                {/* TABLE DATA */}
            <div className="divisionToApprove">

            </div>
            
                <div className="myDepartmentLists">
                   
                  {this.state.userDepartments.map(department => 
                      <div className="myDepartmentListsContents">
                      <h2>{department.centerName}</h2>
                      {department.isApproved ? 
                        <h5>Member</h5>
                      : <h5>Not a member yet</h5>}
                    </div>
                    )}
                    {/* userDepartments: [], */}
                    {this.state.userDepartments.length === 0 ? 
                    <div className="noDepartmentContainer">
                      <h5>You don't have a department.</h5>
                      <div className="noDeptBtnContainer">
                        <button className="noDeptSelectBtn" onClick={this.handleShowSelectDepartmentModal}>Select Department</button>
                      </div>
                    </div>
                    :
                    <div className="addDepartmentInputContainer">
                    <h4>Add Department:</h4>
                    <input className="addDepartmentInput" 
                          type="text" 
                          list="departmentList"
                          onChange={this.handleToAddDept}/>
                          <button className="addRequestDept" onClick={!this.state.send ? this.handleSubmitDept : null}>Request Department</button>
                          <datalist id="departmentList">
                          {this.state.departmentLists.map(data => 
                          <option value={data}/>
                      )}
                      </datalist>
                    </div>
                    }
                   
                </div>
            </div>
        </div>

      )}
    </CrfContext.Consumer>
        )
    }
}

const link ={
    textDecoration: "none",
    color: "black"
}

export default MyDepartments
